import api from "@/services/api"
import { queryClient } from "@/queryClient"
import type { CreateEditProductRequest } from "../sharedTypes/products"
import { BASE_PRODUCTS_QUERY_KEY } from "@/services/queryKeys"

export const updateProduct = async (
  productId: string,
  params: CreateEditProductRequest
) => {
  await api.put(`/products/products/${productId}`, {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
}
